export default __webpack_public_path__ + "static/media/power.251470e9.png";